<div class="card-header">
  <div class="title-section">
    <h5 class="header-title">Histórico</h5>
  </div>
  <div class="button-section">
    <span class="p-input-icon-left search-input">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        (input)="dt?.filterGlobal($any($event.target).value, 'contains')"
        placeholder="Buscar..."
        class="p-inputtext-sm"
        appPermissionControl="P156K0001"
      />
    </span>
    <button mat-flat-button (click)="close()" class="btn-delete" appPermissionControl="P156B0001">
      <mat-icon>close</mat-icon>
      Cerrar
    </button>
  </div>
</div>

<p-table
  #dt
  [value]="dataSource.data"
  [columns]="columns"
  [paginator]="true"
  [rows]="10"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 15, 20]"
  [scrollable]="true"
  scrollHeight="400px"
  styleClass="p-datatable-gridlines"
  [resizableColumns]="true"
  [autoLayout]="true"
  responsiveLayout="scroll"
  [loading]="loading"
  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
  appPermissionControl="P156T0001"
>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th *ngFor="let col of columns" [pSortableColumn]="col.field" class="th-prime" appPermissionControl="P156C0006">
        {{ col.header }}
        <p-sortIcon [field]="col.field"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr>
      <td *ngFor="let col of columns" class="td-prime">
        {{ rowData[col.field] }}
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5" class="text-center td-prime">
        <span *ngIf="allData > 0">No hay resultados para la búsqueda</span>
        <span *ngIf="allData == 0 && !loading">No hay datos para mostrar</span>
        <mat-spinner *ngIf="loading" class="spinner"></mat-spinner>
      </td>
    </tr>
  </ng-template>
</p-table>
